/* eslint-disable */

export const createOrg = /* GraphQL */ `
  mutation createOrg($input: CreateOrgInput) {
    createOrg(input: $input) {
      name
      id
    }
  }
`;

export const createCourse = /* GraphQL */ `
  mutation CreateCourse($input: CourseInput) {
    createCourse(input: $input) {
      id
      name
      org
      role
      autoEnrollment {
        enabled
        start
        end
      }
    }
  }
`;

export const updateCourse = `
  mutation UpdateCourse($input: CourseUpdateInput) {
    updateCourse(input: $input) {
      id
      name
      org
      orgId
      autoEnrollment {
        enabled
        start
        end
      }
    }
  }
`;

export const deleteCourse = `
  mutation DeleteCourse($id: ID!) {
    deleteCourse(id: $id) {
      id
      name
      org
    }
  }
`;

export const addCourseMember = /* GraphQL */ `
  mutation AddCourseMember($input: CourseMemberInput) {
    addCourseMember(input: $input) {
      courseId
      userId
      role
    }
  }
`;

export const updateCourseMember = /* GraphQL */ `
  mutation UpdateCourseMember($input: CourseMemberInput) {
    updateCourseMember(input: $input) {
      courseId
      userId
      role
      givenName
      familyName
    }
  }
`;

export const deleteCourseMember = /* GraphQL */ `
  mutation DeleteCourseMember($input: CourseMemberInput) {
    deleteCourseMember(input: $input) {
      courseId
      userId
      role
    }
  }
`;

export const createActivity = /* GraphQL */ `
  mutation CreateActivity($input: ActivityInput) {
    createActivity(input: $input) {
      id
      resourceLinkId
      name
      type
      courseId
      courseName
      org
    }
  }
`;

export const updateActivity = /* GraphQL */ `
  mutation UpdateActivity($input: ActivityUpdateInput) {
    updateActivity(input: $input) {
      id
      resourceLinkId
      name
      type
      courseId
      courseName
      org
    }
  }
`;


export const deleteActivity = /* GraphQL */ `
  mutation DeleteActivity($id: ID!) {
    updateActivity(id: $id) {
      id
    }
  }
`;

export const updateUserInfo = /* GraphQL */ `
  mutation setUserInfo {
    setUserInfo {
      givenName
      familyName
      tocAccepted
    }
  }
`;

export const acceptTOC = /* GraphQL */ `
  mutation setUserInfo($input: UserInfoInput) {
    setUserInfo(input: $input) {
      givenName
      familyName
      tocAccepted
    }
  }
`;

export const generateJwt = /* GraphQL */ `
  mutation generateJwt($payload: String!) {
    generateJwt(payload: $payload)
  }
`;

export const enrollCurrentUserInCourse = /* GraphQL */ `
  mutation autoEnrollCaller($input: AutoEnrollInput) {
    autoEnrollCaller(input: $input) {
      courseId
      userId
      role
    }
  }
`;

